import { render, staticRenderFns } from "./ExtraPlanModal.vue?vue&type=template&id=fff0dd76"
import script from "./ExtraPlanModal.vue?vue&type=script&lang=js"
export * from "./ExtraPlanModal.vue?vue&type=script&lang=js"
import style0 from "./ExtraPlanModal.vue?vue&type=style&index=0&id=fff0dd76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports